import { Button, Checkbox, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";

const StyledPaperDiv = styled("div")({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "500px",
    height: "250px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    alignItems: "center",
    borderRadius: "3px",
    boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const StyledModalHeader = styled(Typography)({
    alignSelf: "center",
    marginTop: "5%",
});

const StyledFormContainer = styled("div")({
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    width: "80%",
    height: "90%",
});

const StyledSubmitButtonsContainer = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignSelf: "end",
    paddingBottom: "15px",
});

const StyledSyncCheckbox = styled(Checkbox)({
    padding: 0,
    paddingRight: "15px",
});

const StyledSyncDesc = styled("span")({
    cursor: "pointer",
});

const StyledSyncContainer = styled("span")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
});

const SaveAndSyncModal = (props) => {
    const { isOpen, toggleModal, handleSubmit } = props;

    const [syncChangesCheckbox, toggleSyncChangesCheckbox] = useState(false);

    const toggleModalClose = () => {
        toggleModal(false);
    };

    const toggleSyncChanges = () => {
        toggleSyncChangesCheckbox(!syncChangesCheckbox);
    };

    return (
        <Modal
            aria-labelledby="save-and-sync-modal"
            aria-describedby="saves information of property and syncs to all pertaining linked properties"
            open={isOpen}
            onClose={toggleModalClose}
        >
            <StyledPaperDiv>
                <StyledModalHeader variant="h5">Sync Changes?</StyledModalHeader>
                <StyledFormContainer>
                    <p>
                        This Asset Service record shares the same Accounting System Software ID with other properties.
                    </p>
                    <StyledSyncContainer onClick={toggleSyncChanges}>
                        <StyledSyncCheckbox color="primary" checked={syncChangesCheckbox} />
                        <StyledSyncDesc>Check to apply changes to all linked properties.</StyledSyncDesc>
                    </StyledSyncContainer>
                    <SubmitButtons
                        toggleModalClose={toggleModalClose}
                        handleSubmit={() => handleSubmit(syncChangesCheckbox)}
                    />
                </StyledFormContainer>
            </StyledPaperDiv>
        </Modal>
    );
};

const SubmitButtons = (props) => {
    const { toggleModalClose, handleSubmit } = props;
    const closeModal = () => {
        toggleModalClose();
    };
    return (
        <StyledSubmitButtonsContainer>
            <Button variant="contained" color="default" onClick={closeModal}>
                Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
                Save
            </Button>
        </StyledSubmitButtonsContainer>
    );
};

export default SaveAndSyncModal;
